import React from 'react';
// @ts-ignore
import styles from './InvoicingCard.module.scss';

export const Variant = {
	commission: 'commission',
	invoiced: 'invoiced',
	commissionForecast: 'commissionForecast',
	invoicedForecast: 'invoicedForecast',
};

const STYLES = {
	[Variant.commission]: {
		backgroundImage: 'linear-gradient(to bottom, #9ac729, #619612)',
	},
	[Variant.commissionForecast]: {
		backgroundColor: 'rgba(216,220,228, 0.5)',
	},
	[Variant.invoiced]: {
		backgroundColor: 'rgba(116, 194, 0, 0.5)',
	},
	[Variant.invoicedForecast]: {
		backgroundColor: '#f4f3fd',
	},
};

interface Props {
	variant: keyof typeof Variant;
	label: string;
	price: string;
}

const InvoicingCard: React.FC<Props> = ({
	label,
	price,
	variant = Variant.commission,
}) => (
	<div className={styles.wrapper}>
		<div className={styles.indicator} style={STYLES[variant]} />
		<div>
			<p className={styles.label}>{label}</p>
			<p className={styles.price}>{price}</p>
		</div>
	</div>
);

export default InvoicingCard;
